import { useEffect, useState } from 'react'
import { Q2_START, Q2_END } from '../data/pillars.js'

/**
 * Live-updating countdown to end of Q2 2026.
 *
 * Mirrors q2-goals.html line 4005-4009 and line 4101-4104. Updates every
 * 60 seconds (more than enough precision for a day-level countdown).
 *
 * Visual: shows "X days, Y hours" + a progress bar for Q2 completion.
 */
export default function CountdownTimer() {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(timer)
  }, [])

  const secsLeft = Math.max(0, Math.floor((Q2_END - now) / 1000))
  const daysLeft = Math.floor(secsLeft / 86400)
  const hoursLeft = Math.floor((secsLeft % 86400) / 3600)
  const urgent = daysLeft < 14

  // Q2 progress percentage (0–100)
  const totalMs = Q2_END - Q2_START
  const elapsedMs = Math.max(0, Math.min(totalMs, now - Q2_START))
  const pctComplete = Math.round((elapsedMs / totalMs) * 100)

  return (
    <div className="countdown">
      <div>
        <div className="countdown-label">Q2 Ends</div>
        <div className={`countdown-value ${urgent ? 'urgent' : ''}`}>
          {daysLeft}d {hoursLeft}h
        </div>
      </div>
      <div className="countdown-progress" title={`${pctComplete}% of Q2 elapsed`}>
        <div className="countdown-progress-fill" style={{ width: `${pctComplete}%` }} />
      </div>
      <div style={{ color: 'var(--muted)', fontSize: 11, fontWeight: 600 }}>
        {pctComplete}% complete
      </div>
    </div>
  )
}
